"use client"
import {
  BottomSheet,
  BottomSheetBody,
  BottomSheetFooter,
  BottomSheetFooterButton,
  BottomSheetHeader,
  BottomSheetHeaderTitle,
} from "@opensea/ui-kit"
import { useTranslations } from "next-intl"
import type React from "react"
import { useContextSelector } from "use-context-selector"
import { useClearFilters } from "@/hooks/query-param/use-clear-filters"
import { FilterLayoutContext } from "../layout/FilterLayoutProvider"
import { withSuspense } from "../suspense/WithSuspense"

type Props = {
  children: React.ReactNode
}

export const FilterSheet = withSuspense(function FilterSheet({
  children,
}: Props) {
  const [isFilterSheetOpen, setIsFilterSheetOpen] = useContextSelector(
    FilterLayoutContext,
    v => [v.isFilterSheetOpen, v.setIsFilterSheetOpen],
  )

  const clearAll = useClearFilters()
  const t = useTranslations("FilterSheet")

  return (
    <BottomSheet
      content={
        <>
          <BottomSheetHeader>
            <BottomSheetHeaderTitle>{t("title")}</BottomSheetHeaderTitle>
          </BottomSheetHeader>
          <BottomSheetBody>{children}</BottomSheetBody>
          <BottomSheetFooter className="flex-row">
            <BottomSheetFooterButton
              onClick={() => {
                clearAll()
                setIsFilterSheetOpen(false)
              }}
              variant="secondary"
            >
              {t("clearCta")}
            </BottomSheetFooterButton>
            <BottomSheetFooterButton
              onClick={() => {
                setIsFilterSheetOpen(false)
              }}
            >
              {t("doneCta")}
            </BottomSheetFooterButton>
          </BottomSheetFooter>
        </>
      }
      onOpenChange={setIsFilterSheetOpen}
      open={isFilterSheetOpen}
    />
  )
})
